/* Imports */
import React from "react"
import { SrOnly } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

const SrOnlyPage = () => {
    const items = [
        {
            content: <SrOnly as="h1">Hello</SrOnly>,
            code: '<SrOnly as="h1">Hello</SrOnly>',
        },
    ]

    return <ComponentPage items={items} />
}

export default SrOnlyPage
